import _typeof from './typeof'
import toPrimitive from './toPrimitive'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toPropertyKey = (t: any): any => {
  const i = toPrimitive(t, 'string')
  return 'symbol' == _typeof(i) ? i : i + ''
}

export default toPropertyKey
